import { getGLobalRepoUrl } from "./api-services";
import axios from "axios";
import urls from "./urls";
import { $session } from "@/helpers";

// === Base URL for Educational Material API ===
const baseUrl = getGLobalRepoUrl("/edumaterial");

export const getAllEducationalMaterial = (payload, pageableParams = {}) => {
  return axios.post(baseUrl, payload, { params: pageableParams });
};

export const getEducationalMaterialById = (id) => axios.get(`${baseUrl}/${id}`);

export const addEducationalMaterial = (data) =>
  axios.post(`${baseUrl}/addMaterialdata`, data);

export const updateEducationalMaterial = (data) =>
  axios.put(`${baseUrl}/updateMaterialdata/`, data);

export const getCaseDetailsByNumber = (tumorSiteId, caseNumbers) => {
  return axios.post(`${baseUrl}/getcasedetails`, {
    tumorSiteId,
    caseNumbers,
  });
};

export const deleteEducationalMaterial = (id) =>
  axios.delete(`${baseUrl}/${id}`);

export const deleteEduMaterialTumorCase = (id) =>
  axios.delete(`${baseUrl}/lineitem/${id}`);

export const getMetaDataListFact = (params, data) => {
  const tenantData = $session.getTenantData();
  const headers = {
    "Content-Type": "application/json",
    "X-Tenant-Id": tenantData?.id, // match direct call
  };

  const url = `${getGLobalRepoUrl(`/${urls.searchMetaData}`)}?page=${
    params.page
  }&size=${params.size}&sort=${params.sort}&isSorted=${params.isSorted}`;
  return axios.post(url, data, { headers });
};

export const getEduMaterialCaseDetails = (id, tumorSiteId) => {
  const tenantData = $session.getTenantData();
  const headers = {
    "Content-Type": "application/json",
    "X-TenantId": tenantData?.id, // match direct call
  };
  return axios.get(
    `${baseUrl}/getallcasesofmaterial?tumorSiteId=${tumorSiteId}&id=${id}`,
    { headers }
  );
};

export const updateEducationalMaterialCaseOrder = (data) => {
  const tenantData = $session.getTenantData();
  const headers = {
    "Content-Type": "application/json",
    "X-TenantId": tenantData?.id,
  };
  return axios.post(`${baseUrl}/caseorder/update`, data, { headers });
};

export const getAllEducationalMaterialFolderByUserId = (userId) => {
  return axios.get(`${baseUrl}/allfolders?userId=${userId}`);
};

export const getMaterialByFolder = (params, body = {}) => {
  return axios.post(`${baseUrl}/getmaterialbyfolder`, body, { params });
};

export const moveToUserFolder = (data) =>
  axios.put(`${baseUrl}/movetouserfolder`, data);
export const moveToPublicbox = (data) =>
  axios.put(`${baseUrl}/movetopublicbox`, data);
export const approveMaterialPublication = (data) =>
  axios.put(`${baseUrl}/approvepublication`, data);

export const saveAssignmentMaterialComment = (data) => {
  const tenantData = $session.getTenantData();
  const siteData = $session.getSiteData();
  const headers = {
    "Content-Type": "application/json",
    "X-SiteId": siteData?.id,
    "X-TenantId": tenantData?.id, // match direct call
  };
  return axios.post(`${baseUrl}/saveassignmentdetails`, data, { headers });
};

export const sendEmail = (data) => {
  const tenantData = $session.getTenantData();
  const headers = {
    "Content-Type": "application/json",
    "X-TenantId": tenantData?.id, // match direct call
  };
  return axios.post(`${baseUrl}/email`, data, { headers });
};


export const tumorSiteMapping = (data, token) => {
  const tenantData = $session.getTenantData();
  const headers = {
    "Content-Type": "application/json",
    authorization: token,
    "X-TenantId": tenantData?.id,
  };
  return axios.post(`${baseUrl}/tumorsitemapping`, data, { headers });
};


export const assignMaterialToUsers = (body) => {
  return axios.post(`${baseUrl}/assigntouser`, body);
};

export const reassignMaterialToUsers = (body) => {
  return axios.post(`${baseUrl}/updateassignment`, body);
};

export const getAssignedDetail = (randomId) => {
  return axios.get(`${baseUrl}/getassigneddetail`, {
    params: { recipientId: randomId },
    headers: {
      "X-TenantID": $session.getTenantData()?.id,
    },
  });
};

export const checkValidAssignment = (randomId) => {
  const tenantData = $session.getTenantData();
  return axios.get(`${baseUrl}/checkvalidassignment`, {
    params: { recipientId: randomId },
    headers: {
      "X-TenantID": tenantData?.id,
    },
  });
};

export const getAssignedToUsersList = (params, body = {}) => {
  return axios.post(`${baseUrl}/getassignedtouserlist`, body, { params });
};

export const getRecipientsList = (params, body = {}) => {
  return axios.post(`${baseUrl}/getresponsesfromrecipients`, body, { params });
};

export const getAnswerReport = (assignmentId, materialId) => {
  if (materialId != null) {
    return axios.post(`${baseUrl}/getanswerreport`, { materialId });
  }
  return axios.get(`${baseUrl}/generateanswer?assignmentId=${encodeURIComponent(assignmentId)}`);
};

export const shareAnswer = (assignmentId, data) => {
  return axios.post(
    `${baseUrl}/generateanswer?assignmentId=${encodeURIComponent(assignmentId)}`,
    data,
  );
};

export const createAnswerPdfLink = (materialId, data) =>
  axios.post(`${baseUrl}/answerpdflink`, { ...data, materialId });

export const viewResponseOfRecipient = (recipientId, attemptId) => {
  return axios.get(`${baseUrl}/responsepdf`, {
    params: { recipientId, attemptId },
    responseType: "blob",
  });
};

export const deleteResponseOfRecipient = (data) =>
  axios.put(`${baseUrl}/deleteresponse`, data);

export const deleteAssignment = (id) =>
  axios.delete(`${baseUrl}/deleteassignment/${id}`);
